import { Typography, Paper } from '@mui/material'
import { useTranslation } from 'react-i18next'
import CheckRiskStatus from '../components/CheckRiskStatus'

const CheckAssignedUsers = ({ assignedUsersCheck }) => {
  const { t } = useTranslation(['common'])
  const users = Array.isArray(assignedUsersCheck) ? assignedUsersCheck : []
  const hasChecks = users.length > 0
  const checkLength = users.length

  return (
    <>
      <Paper elevation={0} variant="colorPrimary" sx={{ display: 'flex', justifyContent: 'space-between' }}>
        <Typography>{t('common:assignedUsers')}</Typography>
        <CheckRiskStatus checkLength={checkLength} hasChecks={hasChecks} label={t('common:user')} />
      </Paper>
      {hasChecks && (
        <Paper variant="rootOutlined" elevation={0} sx={{ flex: 1 }}>
          <div className="c-detail-grid">
            {users.map((user, index) => (
              <div key={index} className="c-detail-row">
                <Typography variant="subtitle1">{t('common:email')}</Typography>
                <Typography variant="subtitle3">{user.email}</Typography>
              </div>
            ))}
          </div>
        </Paper>
      )}
    </>
  )
}

export default CheckAssignedUsers
